// appSettings namespace — logged-in Settings page (Settings.tsx).
// Keys mirror en/appSettings.ts exactly. Exact current Polish strings verbatim.
export const appSettings = {
  nav: {
    profil: 'Profil',
    powiadomienia: 'Powiadomienia',
    konto: 'Konto',
    jezyk: 'Język i region',
    danger: 'Usuń konto',
    logout: 'Wyloguj się',
  },
  profil: {
    heading: 'Profil',
    sub: 'Jak się do Ciebie zwracamy w aplikacji i w mailach.',
    nameCardTitle: 'Nazwa',
    nameCardSub: 'Używamy jej w powiadomieniach. Nie jest publiczna.',
    nameLabel: 'Nazwa artysty lub labelu',
    nameHint: 'Do 80 znaków. Możesz ją zmienić w każdej chwili.',
    save: 'Zapisz',
    // Słowo stanu w pasku zapisu (reguła 14 języka): fakt, nie zdanie.
    unsaved: 'Niezapisane zmiany',
    savedWord: 'Zapisano',
    saveFailedWord: 'Zapis się nie powiódł. Spróbuj ponownie.',
    // Początek `nameHint` — w slocie pod polem stoi sam limit.
    nameHintShort: 'Do 80 znaków.',
    saving: 'Zapisuję…',
    saved: 'Zapisane.',
    clear: 'Usuń nazwę',
    failed: 'Nie udało się zapisać. Spróbuj ponownie.',
  },
  powiadomienia: {
    heading: 'Powiadomienia',
    cardTitle: 'Maile, które możesz wyłączyć',
    cardSub: 'Wysyłamy je na {email}.',
    notify_render: 'Gotowy edit',
    notify_publish: 'Publikacja',
    notify_product: 'Nowości w EDIMI',
    saved: 'Zapisane.',
    failed: 'Nie udało się zapisać ustawienia. Spróbuj ponownie.',
    // Wiersz z nieaktywnym przełącznikiem i pigułką zamiast zdania (zasada 8).
    billing: 'Faktury i płatności',
    billingSub: 'zmiany ceny lub regulaminu, bezpieczeństwo konta',
    always: 'zawsze',
    alwaysTitle: 'Maile, których nie da się wyłączyć',
  },
  konto: {
    heading: 'Konto',
    sub: 'Adres e-mail i hasło do logowania w EDIMI.',
    emailCardTitle: 'Adres e-mail',
    emailCardSub: 'Na ten adres wysyłamy faktury i powiadomienia.',
    emailLabel: 'E-mail',
    verified: 'potwierdzony',
    unverified: 'niepotwierdzony',
    emailChangeFoot: 'Na nowy adres wyślemy link potwierdzający; zmiana nastąpi po jego kliknięciu.',
    resend: 'Wyślij link ponownie',
    changeEmail: 'Zmień e-mail',
    changePassword: 'Zmień hasło',
    // Wiersz „Pozostałe urządzenia” z akcją-linkiem „Wyloguj”.
    devices: 'Pozostałe urządzenia',
    signOut: 'Wyloguj',
    // Krótki toast po wysłaniu linku (08h); pełne zdanie zostaje w `emailChangeSent`.
    emailChangeSentShort: 'Wysłaliśmy link potwierdzający na nowy adres.',
    newEmailLabel: 'Nowy adres e-mail',
    newEmailPlaceholder: 'nowy@adres.pl',
    emailPwLabel: 'Potwierdź hasłem',
    emailPwPlaceholder: 'Twoje hasło',
    emailChangeCancel: 'Anuluj',
    emailChangeSubmit: 'Wyślij link potwierdzający',
    emailChangeSending: 'Wysyłam…',
    emailChangeSent: 'Jeśli adres jest wolny, wysłaliśmy na niego link potwierdzający. Obecny e-mail działa do czasu potwierdzenia.',
    emailChangeSame: 'To już jest Twój obecny adres e-mail.',
    emailChangeInvalid: 'Podaj prawidłowy adres e-mail.',
    emailChangeFailed: 'Nie udało się rozpocząć zmiany e-maila. Spróbuj ponownie.',
    resendMsg: 'Jeśli konto istnieje i nie jest potwierdzone, wysłaliśmy link.',
    pwCardTitle: 'Hasło',
    currentPwLabel: 'Obecne hasło',
    currentPwPlaceholder: 'Obecne hasło',
    newPwLabel: 'Nowe hasło',
    newPwPlaceholder: 'Nowe hasło',
    repeatPwLabel: 'Powtórz nowe hasło',
    repeatPwPlaceholder: 'Powtórz',
    pwFoot: 'Zostaniesz zalogowany tutaj; inne urządzenia zostaną wylogowane.',
    pwSaving: 'Zapisuję…',
    pwUpdate: 'Zaktualizuj hasło',
    pwWeak: 'Hasło: min. 8 znaków, w tym wielka litera i cyfra.',
    pwMismatch: 'Nowe hasła nie są takie same.',
    pwUpdated: 'Hasło zaktualizowane.',
    pwCurrentWrong: 'Obecne hasło jest nieprawidłowe.',
    pwTooWeak: 'Nowe hasło jest zbyt słabe.',
    pwFailed: 'Nie udało się zmienić hasła.',
    sessionsCardTitle: 'Aktywne sesje',
    sessionsCardSub: 'Jednym kliknięciem wylogujesz wszystkie pozostałe urządzenia. Tutaj pozostaniesz zalogowany.',
    sessionsFoot: 'Nie poznajesz urządzenia? Wyloguj pozostałe, a potem zmień hasło.',
    signOutOthers: 'Wyloguj pozostałe',
    sessionsBusy: 'Wylogowuję…',
    sessionsDone: 'Wszystkie pozostałe urządzenia zostały wylogowane.',
    sessionsFailed: 'Nie udało się wylogować pozostałych urządzeń. Spróbuj ponownie.',
  },
  jezyk: {
    heading: 'Język i region',
    sub: 'Wpływa na język interfejsu i format dat.',
    cardTitle: 'Język interfejsu',
    polish: 'Polski',
    polishSub: 'Domyślny',
    english: 'English',
    // Decyzja 3 sesji 11: konsekwencja zamiast pigułki „Beta”.
    englishSub: 'Część komunikatów może być jeszcze po polsku.',
    saved: 'Zapisano.',
    saveFailed: 'Nie udało się zapisać języka.',
  },
  danger: {
    heading: 'Usuń konto',
    sub: 'Operacje nieodwracalne.',
    cardTitle: 'Usuń konto na stałe',
    cardSub: 'Usuniemy Twoje materiały, edity i dane profilu. Dokumenty rozliczeniowe zachowamy tak długo, jak wymagają tego przepisy podatkowe.',
    rowTitle: 'Trwałe usunięcie konta',
    rowSub: 'Tej operacji nie da się cofnąć. Niewykorzystane tokeny przepadają.',
    deleteBtn: 'Usuń konto',
    // Jedyne zdanie okna kasującego: fakt o tokenach (T-08 zdjęło „nie da się cofnąć”).
    confirmBody: 'Niewykorzystane tokeny przepadają.',
    confirmLabel: 'Potwierdź hasłem',
    confirmPlaceholder: 'Twoje obecne hasło',
    cancel: 'Anuluj',
    confirmBtn: 'Usuń konto na stałe',
    busy: 'Usuwam…',
    wrongPassword: 'Hasło jest nieprawidłowe.',
    failed: 'Nie udało się usunąć konta. Spróbuj ponownie lub napisz: kontakt@edimi.ai.',
  },
}
